import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "mc_analytics_consent"

export default class extends Controller {
  static values = { measurementId: String }

  connect() {
    if (!this.measurementIdValue) return

    this.handleTurboLoad = this.trackPageview.bind(this)
    this.handleConsentAccepted = this.onConsentAccepted.bind(this)

    document.addEventListener("turbo:load", this.handleTurboLoad)
    window.addEventListener("analytics:accepted", this.handleConsentAccepted)

    // Fire initial pageview if consent was already granted
    if (this.hasConsent()) {
      this.grantConsent()
      this.trackPageview()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.handleTurboLoad)
    window.removeEventListener("analytics:accepted", this.handleConsentAccepted)
  }

  // -- private ---------------------------------------------------------------

  onConsentAccepted() {
    this.grantConsent()
    this.trackPageview()
  }

  grantConsent() {
    if (typeof gtag === "undefined") return
    gtag("consent", "update", { analytics_storage: "granted" })
  }

  trackPageview() {
    if (typeof gtag === "undefined" || !this.hasConsent()) return

    gtag("config", this.measurementIdValue, {
      page_path: location.pathname + location.search
    })
  }

  hasConsent() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`))
    return match && match[1] === "accepted"
  }
}
